import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';

import { Table, Column, Button, BooleanValue } from '@smartplatform/ui';
import store from '../../store';
import { groups } from '../documents/groups';
import ExportDiscussions from './ExportDiscussions';

@observer
export default class List extends React.Component {
	@observable records = null;

	constructor(props) {
		super(props);
		this.init();
	}

	init = async () => {
		this.records = await store.model.Discussion.find({ order: 'id desc', include: ['comments', 'poll'] });
	};

	create = () => this.props.history.push('/admin/discussions/create');

	docName = document => (
		<span title={document.id}>
			{document.freeNum}: {document.name}
		</span>
	);
	docGroup = document => groups[document.docGroup];

	computedComments = record => {
		const comments = record.comments();
		return `${comments.filter(e => e.publish).length} / ${comments.length}`;
	};

	render() {
		if (!this.records) return '...';

		return (
			<>
				<p>Обсуждения</p>
				<p>
					<Button className="btn-primary" onClick={this.create}>
						Создать
					</Button>
				</p>

				<ExportDiscussions />
				<Table records={this.records} rootPath="/admin" path="discussions">
					{/* <Column relation="document" computed={this.docName} label="Документ" />
					<Column relation="document" computed={this.docGroup} label="Тип" /> */}
					<Column property="name" label="Заголовок" />
					<Column computed={this.computedComments} label="Комментарии (принято/всего)" />
					<Column computed={record => !!record.pollId} label="Голосование">
						<BooleanValue />
					</Column>
					<Column width={75} className="text-center" property="publish" label="Опубликовано" />
				</Table>
			</>
		);
	}
}
